import * as Sentry from '@sentry/browser';
import {EVENT, ONBOARDING_WORKFLOW} from 'constants';


window.dataLayer = window.dataLayer || [];
const dl = window.dataLayer;

function gtag (...args) {
  dl.push(args);
}

function gaEvent (action, label, hitType = EVENT, category = ONBOARDING_WORKFLOW) {
  // The try block is used catch any exceptions that may occur in calling gtag() to avoid
  // breaking the flow of execution in whichever context gaEvent() is called.
  try {
    gtag(hitType, action, {
      event_category: category,
      event_label: label,
    });
  } catch (exception) {
    Sentry.captureException(exception);
  }
}

export default gaEvent;
